import { create } from 'zustand'

export type EventTypeFilter =
  | 'deal'
  | 'notes'
  | 'reminder'
  | 'samples'
  | 'email'
  | 'contactcompany'
  | 'document'

export type FilterCriteria = 'one' | 'all' | 'neither'

export interface EventHistoryFilterState {
  // Applied filters (used in API calls)
  eventTypes: EventTypeFilter[]
  teamMemberIds: number[]
  criteria: FilterCriteria

  // Pending filters (shown in modal, not yet applied)
  pendingEventTypes: EventTypeFilter[]
  pendingTeamMemberIds: number[]
  pendingCriteria: FilterCriteria

  // Actions
  setPendingEventTypes: (eventTypes: EventTypeFilter[]) => void
  setPendingTeamMemberIds: (teamMemberIds: number[]) => void
  setPendingCriteria: (criteria: FilterCriteria) => void
  applyFilters: () => void
  clearAllFilters: () => void
  syncPendingFilters: () => void
}

export const useEventHistoryFilterStore = create<EventHistoryFilterState>(
  (set, get) => ({
    // Applied filters
    eventTypes: [],
    teamMemberIds: [],
    criteria: 'all',

    // Pending filters
    pendingEventTypes: [],
    pendingTeamMemberIds: [],
    pendingCriteria: 'all',

    // Set pending filters
    setPendingEventTypes: (eventTypes) => {
      set({ pendingEventTypes: eventTypes })
    },

    setPendingTeamMemberIds: (teamMemberIds) => {
      set({ pendingTeamMemberIds: teamMemberIds })
    },

    setPendingCriteria: (criteria) => {
      set({ pendingCriteria: criteria })
    },

    // Apply pending filters
    applyFilters: () => {
      const state = get()
      set({
        eventTypes: state.pendingEventTypes,
        teamMemberIds: state.pendingTeamMemberIds,
        criteria: state.pendingCriteria,
      })
    },

    // Clear all filters
    clearAllFilters: () => {
      set({
        eventTypes: [],
        teamMemberIds: [],
        criteria: 'all',
        pendingEventTypes: [],
        pendingTeamMemberIds: [],
        pendingCriteria: 'all',
      })
    },

    // Sync pending with applied (for when modal opens)
    syncPendingFilters: () => {
      const state = get()
      set({
        pendingEventTypes: state.eventTypes,
        pendingTeamMemberIds: state.teamMemberIds,
        pendingCriteria: state.criteria,
      })
    },
  })
)
